module.exports = __webpack_public_path__ + "static/media/question.acde8683.svg";